export default __webpack_public_path__ + "static/media/Chhattisgarhi_bm_1.0f20c5e8.mp3";